import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-generic-contact-details',
    templateUrl: './generic-contact-details.component.html',
    styleUrls: ['./generic-contact-details.component.scss'],
    standalone: false
})
export class GenericContactDetailsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
